import { WindowPercentageArea } from '@nx-customer-apps/shared/enums';
import { EnumDictionary } from '../types';

export const windowPercentageAreaToPhraseKeyDictionary: EnumDictionary<WindowPercentageArea, string> = {
    [WindowPercentageArea.Small]: 'HEATLOAD.WINDOWS_AND_GLAZING.SMALL',
    [WindowPercentageArea.Medium]: 'HEATLOAD.WINDOWS_AND_GLAZING.MEDIUM',
    [WindowPercentageArea.Large]: 'HEATLOAD.WINDOWS_AND_GLAZING.LARGE'
};
